<template>
  <v-container>
    <v-row
        no-gutters
        justify="center"
        align="center"
    >
      <v-col cols="12" md="8" xs="12">
        <location-menu-section-title-modal
            :title="formData.title"
            v-on:action="handleSectionAction"
            :action="updateTitle"
        />
      </v-col>
    </v-row>

    <v-row
        no-gutters
        v-for="(item, index) in formData.items"
        :key="item.key"
        justify="center"
        align="center"
    >
      <v-col cols="12" md="8" xs="12">
        <location-menu-item-modal
            :title="item.title"
            :description="item.description"
            :price="item.price"
            :priceFormatted="item.price_formatted"
            :action="i => updateItem(index, i)"
            v-on:action="val => handleAction(val, index, item)"
        />
      </v-col>
    </v-row>

    <v-row
        no-gutters
        justify="center"
        align="center"
    >
      <v-col cols="12" md="8" xs="12" v-if="this.formData.items.length < this.limit">
        <location-menu-item-modal
            clearOnSubmit
            no-action-icon
            :action="item => addOne(null, item)"
            add-item-back-color="#8C9EFF"
            add-item-text-color="#FFF">
          <p class="text-subtitle-2 pt-1 my-0">Adicionar item</p>
        </location-menu-item-modal>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LocationMenuItemModal from '@/views/Locations/Modals/LocationMenuItemModal'
import LocationMenuSectionTitleModal from '@/views/Locations/Modals/LocationMenuSectionTitleModal'
export default {
  name: "LocationMenuSection",
  components: {
    LocationMenuItemModal,
    LocationMenuSectionTitleModal
  },
  props: {
    limit: {
      type: Number,
      required: true
    },
    value: Array,
    title: String
  },
  data: () => ({
    formData: {
      title: '',
      items: []
    },
    nextKey: 0
  }),
  methods: {
    handleSectionAction: function(value) {
      this.$emit('action', value)
    },
    handleAction: function(value, index, item) {
      switch (value) {
        case 'FIRST':
          this.moveItem(item, 0, index)
          break
        case 'LAST':
          this.moveItem(item, this.formData.items.length - 1, index)
          break
        case 'UP':
          if (index === 0) break
          this.moveItem(item, index - 1, index)
          break
        case 'DOWN':
          this.moveItem(item, index + 1, index)
          break
        case 'ADD_UP':
          this.addOne(index === 0 ? 0 : index)
          break
        case 'ADD_DOWN':
          this.addOne(index + 1)
          break
        case 'DELETE':
          this.removeOne(null, index)
          break
      }
    },
    change: function() {
      this.$emit('change', this.formData)
    },
    addOne: function(index, { title, description, price } = {title: '', description: '', price: ''}) {
      this.nextKey++
      if (this.formData.items.length < this.limit) {
        if (typeof index === 'number') {
          this.formData.items.splice(index, 0, { title, description, price, key: this.nextKey })
        } else {
          this.formData.items.push({ title, description, price, key: this.nextKey })
        }
      }
      this.change()
    },
    removeOne: function(event, index) {
      if (this.formData.items.length > 0) {
        this.formData.items.splice(index, 1)
        this.change()
      }
    },
    moveItem: function(item, newIndex, oldIndex) {
      this.formData.items.splice(oldIndex, 1)
      this.formData.items.splice(newIndex, 0, item)
      this.change()
    },
    updateItem: function(index, item) {
      this.formData.items[index].title = item.title
      this.formData.items[index].description = item.description
      this.formData.items[index].price = item.price
      this.formData.items[index].price_formatted = item.price ? 'R$ ' + parseFloat(item.price).toFixed(2) : ''
      this.change()
    },
    updateTitle: function(data) {
      this.formData.title = data.title
      this.change()
    }
  },
  created() {
    if (this.value && Array.isArray(this.value)) {
      this.formData.items = this.value.map((i, index) => ({ key: index, ...i}))
      this.nextKey = this.formData.items.length + 1
    }
    this.formData.title = this.title
  },
  watch: {
    value: function (value) {
      this.formData.items = value.map((i, index) => ({ key: index, ...i}))
      this.nextKey = this.formData.items.length + 1
    }
  }
}
</script>

<style scoped>
</style>